import { toDateString } from "@taskfortress/core"
import { useCallback, useState } from "react"
import { BaseScreen, DesktopOnly, MobileOnly } from "../components"
import { Box } from "../components/gluestack/box"
import { TasksDesktop } from "../components/tasks/TasksDesktop"
import { TasksMobile } from "../components/tasks/TasksMobile"

export const TasksScreen = () => {
  const [currentDate, setCurrentDate] = useState(toDateString(new Date()))

  const handleCurrentDateChange = useCallback((date: string) => {
    setCurrentDate(date)
  }, [])

  return (
    <BaseScreen>
      <Box className="flex-1">
        <DesktopOnly>
          <TasksDesktop
            currentDate={currentDate}
            onCurrentDateChange={handleCurrentDateChange}
          />
        </DesktopOnly>

        <MobileOnly>
          <TasksMobile
            currentDate={currentDate}
            onCurrentDateChange={handleCurrentDateChange}
          />
        </MobileOnly>
      </Box>
    </BaseScreen>
  )
}
